<template>
  <div class="data-card">
    <h3 class="mt-0 mb-3">Список товаров</h3>

<!--    <el-form v-if="isEdited" :model="form" :rules="rules" ref="form" class="text-secondary" :class="[{ 'grid-table_border': !isEdited }]">-->
<!--      <div class="row" v-for="(item, index) in form.orderRows" :key="item.id">-->
<!--        <div class="col-2 pr-0">-->
<!--          <el-form-item :prop="`orderRows.${index}.orderNumber`" :rules="required">-->
<!--            <el-input v-model="item.orderNumber" />-->
<!--            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.orderNumber) }">Номер заказа на продажу</span>-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--        <div class="col-2 pr-0">-->
<!--          <el-form-item :prop="`orderRows.${index}.vendorCode`" :rules="required">-->
<!--            <el-input v-model="item.vendorCode" />-->
<!--            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.vendorCode) }">Артикул</span>-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--        <div class="col pr-0">-->
<!--          <el-form-item :prop="`orderRows.${index}.name`" :rules="required">-->
<!--            <el-input v-model="item.name" />-->
<!--            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.name) }">Наименование</span>-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--        <div class="col pr-0">-->
<!--          <el-form-item :prop="`orderRows.${index}.description`" :rules="required">-->
<!--            <el-input v-model="item.description" />-->
<!--            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.description) }">Описание</span>-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--        <div class="col-auto">-->
<!--          <el-form-item prop="orderRowsCount">-->
<!--            <el-input-number v-model="item.count" controls-position="right" :min="1" class="input-number" />-->
<!--            <i @click="removeItemOrderList(index)" class="el-icon-delete el-icon-hover icon-delete pointer ml-3" />-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-form>-->

    <el-table size="small" :data="form.orderRows" max-height="100%" border>
      <el-table-column prop="orderNumber" label="Номера заказов на продажу" min-width="210" />
      <el-table-column prop="vendorCode" label="Код товара" min-width="120"/>
      <el-table-column prop="name" label="Наименование товара" min-width="190" />
      <el-table-column prop="goodsPrice" label="Стоимость" min-width="100">
        <template slot-scope="{row}">
          {{formatPrice(row.goodsPrice)}}
        </template>

      </el-table-column>
      <el-table-column prop="count" label="Количество товара" min-width="110" />
      <el-table-column prop="description" label="Описание товара" min-width="400"/>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { formatPrice } from '@/commons/helpers';

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    showHistoryDialog: false,
    form: {
      orderRows: [],
    },
    rules: {
      number: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          required: true,
          min: 10,
          message: MESSAGES.MIN_LENGTH(10),
          trigger: 'change',
        },
        {
          required: true,
          max: 10,
          message: MESSAGES.MAX_LENGTH(10),
          trigger: 'change',
        },
      ],
      serviceId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // serviceDetail: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      workDate: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // workTime: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
    pickerOptions: {
      firstDayOfWeek: 1,
      // disabledDate(time) {
      //   return time.getTime() < (new Date().getTime() - 1000 * 60 * 60 * 24);
      // },
    },
  }),
  created() {
    this.fetchServices();
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      services: 'servicesDrop/items',
      fetchServicesProgress: 'servicesDrop/fetchProgress',
    }),
  },
  methods: {
    ...mapActions({
      fetchServices: 'servicesDrop/fetchItems',
    }),
    formatPrice,
    fillForm() {
      if (this.item) {
        this.form.orderRows = [...this.item.orderRows];
      } else {
        this.form.orderRows = [];
      }
    },
    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      const form = {
        // number: this.form.number,
        // serviceId: this.form.serviceId,
        // // serviceDetail: this.form.serviceDetail,
        // workDate: this.form.workDate,
        // workTime: this.form.workTime,
      };
      return { isValid, form };
    },
    addItemOrderList() {
      const newItem = {
        orderNumber: '',
        vendorCode: '',
        name: '',
        description: '',
        count: 1,
      };
      this.form.orderRows.push(newItem);
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
<style lang="scss" scoped>
.input-number {
  width: 100px;
}
.icon {
  &-delete {
    font-size: 20px;
  }
}
</style>
